<template>
	<WurldDynamicTag
		v-bind="getAttrs($attrs)"
		:tag="legend ? 'fieldset' : 'div'"
		class="WurldRadioButton"
	>
		<legend
			v-bind="getAttrs($attrs, 'legend')"
			v-if="legend"
		>{{ legend }}</legend>
		<div
			v-bind="getAttrs($attrs, 'group')"
			v-for="(option, key) in options"
			:key="`${guid}${key}`"
			class="WurldRadioButton__group"
		>
			<label
				v-bind="getAttrs($attrs, 'label')"
				v-html="option.label"
				v-if="labelBefore"
				:for="`${guid}${key}`"
			></label>
			<input
				@click="onOptionChange($event.target.value)"
				v-bind="getAttrs($attrs, 'radio')"
				:id="`${guid}${key}`"
				:name="name"
				type="radio"
				:value="option.value"
				:checked="newValue === option.value"
			>
			<label
				v-bind="getAttrs($attrs, 'label')"
				v-html="option.label"
				v-if="!labelBefore"
				:for="`${guid}${key}`"
			></label>
		</div>
	</WurldDynamicTag>
</template>

<script>
import WurldDynamicTag from '@/components/Helpers/WurldDynamicTag';
export default {
	name: 'WurldRadioButton',
	inheritAttrs: false,
	components: {
		WurldDynamicTag
	},
	props: {
		allowDeselect: {
			default: false,
			type: Boolean
		},
		labelBefore: {
			default: false,
			type: Boolean
		},
		legend: {
			default: null,
			type: String
		},
		name: {
			default: null,
			type: String
		},
		options: {
			required: true,
			type: Array
		},
		uid: {
			default: null,
			type: String
		},
		value: {
			default: null,
			type: String
		}
	},
	data () {
		return {
			guid: '',
			newValue: this.value
		};
	},
	mounted () {
		this.guid = this.uid ? this.uid : this.generateUID('WurldRadio');
	},
	methods: {
		onOptionChange (newVal) {
			if (this.allowDeselect && this.newValue === newVal) {
				this.newValue = null;
				this.$emit('input', null);
			} else {
				this.newValue = newVal;
				this.$emit('input', newVal);
			}
		}
	}
};
</script>
